import React from 'react';
import DataTable from '../../components/dataTable';

const GeofenceTable = (props) => {
  const {
    geofenceForm,
    removeRegister,
    attributes,
    list,
    loading,
  } = props;

  return (
    <DataTable
      add={geofenceForm}
      edit={geofenceForm}
      remove={removeRegister}
      list={list}
      loading={loading}
      attributes={attributes}
      keyField={'id'}
      confirmText={`Você está removendo o grupo <strong><field>name</field></strong>! </br>Realmente deseja fazer isso? `}
      headers={[
        {title: 'sharedName', field: 'name', dataSort: true},
      ]}
    />
  );
};

export default GeofenceTable;
